// Angular
import { Component } from '@angular/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
// Service
import { BroadcastService, ToasterType } from '@cv-invision/core';
import { NexsysMonitorService } from '../../service/nexsys-monitor.service';
// Others
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
	selector: 'cv-nexsys-orphan-custom-action-download',
	templateUrl: './custom-action-nexsys-orphan-download.component.html',
	styleUrls: ['./custom-action-nexsys-orphan-download.component.scss']
})
export class CustomActionNexsysOrphanDownloadComponent implements ICellRendererAngularComp {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	public cellValue: any;

	constructor(
		private nexsysMonitorService: NexsysMonitorService,
		private broadcastService: BroadcastService,
	) {}

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
	}

	/**
	 * Download Document
	 */
	onDownloadDocument($event: any): void {
		$event.stopPropagation();
		if (this.cellValue.files && this.cellValue.files.length) {
			const fileLocation = this.cellValue.files[0].location;
			const fileName = this.cellValue.files[0].name;

			this.nexsysMonitorService
				.downloadFile(fileLocation)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(
					result => {
						if (result.blob) {
							this.downloadFile(result.blob, fileName);
							this.broadcastService.broadcast({
								name: ToasterType.SUCCESS,
								event: { message: 'Document successfully downloaded.'}
							});
						}
					},
					error => {
						console.log(error);
					}
				);
		} else {
			this.broadcastService.broadcast({
				name: ToasterType.ERROR,
				event: { error: 'The document does not have files.' }
			});
		}
	}

	/**
	 * Download file
	 */
	downloadFile(src: any = null, filename: string = null): void {
		const element = document.createElement('a');
		element.href = URL.createObjectURL(src);
		element.download = `${filename}`;
		document.body.appendChild(element);
		element.click();
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
